/**
 * InstantSaveChip — says a section or panel saves each change as it is made,
 * so nobody looks for a Save button that will never appear. A neutral pill
 * (the ds StatusPill look) with a success-coloured mark.
 */
import React from 'react';
import { textRole, tokenVars } from '@turn-connect/ui';

export const INSTANT_SAVE_TEXT = 'Saves automatically';

export const InstantSaveChip: React.FC<{ testId?: string }> = ({ testId = 'saves-automatically' }) => (
  <span
    data-testid={testId}
    style={{
      ...textRole('pill'),
      display: 'inline-flex',
      alignItems: 'center',
      gap: 5,
      height: 24,
      boxSizing: 'border-box',
      borderRadius: 999,
      padding: '0 8px',
      background: tokenVars.surfaceMuted,
      border: `1px solid ${tokenVars.border}`,
      whiteSpace: 'nowrap',
    }}
  >
    <span aria-hidden="true" style={{ color: tokenVars.success }}>
      ↻
    </span>
    {INSTANT_SAVE_TEXT}
  </span>
);

export default InstantSaveChip;
